module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-container"
  }, [_c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "brand-item title"
  }, [(!_vm.uploadedImageName) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.brandName) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.uploadedImageName,
      "alt": ""
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ea118f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brand.vue
// module id = 228
// module chunks = 1